import 'slick-carousel/slick/slick.min';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import 'jquery-match-height/dist/jquery.matchHeight-min';
import Isotope from 'isotope-layout/dist/isotope.pkgd.min';
import imagesLoaded from 'imagesloaded/imagesloaded.pkgd.min';


export default class Utils {
    constructor()
    {
        Utils.click();
        Utils.tooltip();
        Utils.fancybox();
        Utils.searchbox();
        Utils.smooth_scroll();
        Utils.lazy();
        Utils.google_translate();
        Utils.on_scroll();
        Utils.match_height();
        Utils.gallery_photos();
        Utils.gallery_videos();
        Utils.blog();
        Utils.flow_flow();
        Utils.responsive();
    }
    
    static click()
    {
    
        const trigger = '[data-trigger="wpiris-click"]';
        
        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    ctrl = true
                }
            })
            $( window ).on( 'keyup', function () {
                ctrl = false
            })
            
            $( document ).on( 'mouseup', trigger, function ( e ) {
                
                if ( e.which == 1 || e.which == 2 ) {
                    let blank = false
                    let url   = $( this ).find( "a" ).attr( "href" )
                    if ( e.which == 2 ) {
                        blank = true
                    } // Clic molette
                    if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                        blank = true
                    }
                    if ( blank || ctrl ) {
                        window.open( url, '_blank' )
                    } else {
                        window.location = url
                    }
                    return false
                }
                return false
                
            } )
        } else {
            $( document ).on( 'click', trigger, function ( e ) {
                
                let blank = false
                let url   = $( this ).find( "a" ).attr( "href" )
                if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                    blank = true
                }
                if ( blank ) {
                    window.open( url, '_blank' )
                } else {
                    window.location = url
                }
                return false
                
            } )
        }
    }
    
    static tooltip()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"]' ).tooltip( { trigger: "hover" } )
        }
    }
    
    static fancybox()
    {

        $( '.hentry a:has(>img):not([target="_blank"]):not("[nofancybox]")' ).attr( 'data-fancybox', 'fancybox' )
        
        $( '[data-fancybox="fancybox"]' ).fancybox( {
            buttons: [
                "zoom",
                "slideShow",
                "close"
            ],
            lang: "fr",
            i18n: {
                fr: {
                    CLOSE: Theme.translate.fancyboxClose,
                    NEXT: Theme.translate.fancyboxNext,
                    PREV: Theme.translate.fancyboxPrev,
                    ERROR: Theme.translate.fancyboxError,
                    PLAY_START: Theme.translate.fancyboxStart,
                    PLAY_STOP: Theme.translate.fancyboxStop,
                    FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                    THUMBS: Theme.translate.fancyboxThumbs,
                    DOWNLOAD: Theme.translate.fancyboxDownload,
                    SHARE: Theme.translate.fancyboxShare,
                    ZOOM: Theme.translate.fancyboxZoom
                },
            },
            caption: function ( instance, item ) {
                let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html()

                if ( !caption ) {
                    caption = $( this ).find( 'img' ).attr( 'title' )
                }

                if ( !caption ) {
                    caption = $( this ).find( 'img' ).attr( 'alt' )
                }

                return caption
            }
        } )

        $( '.js-fancybox' ).on( 'click', function () {
            $.fancybox.open( $( "[data-fancybox='fancybox']" ) );
        } )
    }
    
    static searchbox()
    {
        const trigger  = '[data-trigger="wpiris-search-layout"]',
              close    = '[data-trigger="wpiris-search-layout-close"]',
              $element = $('[data-id="wpiris-search-layout"]');
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            $element.fadeIn().find('input').focus();
        } )
        
        $( document ).on( 'click', close, function ( e ) {
            e.preventDefault();
            $element.fadeOut();
        } )
    }
    
    static smooth_scroll()
    {
        const trigger = '[data-trigger="wpiris-scroll"]';
        
        $( document ).on( 'click', trigger, function ( e ) {
            e.preventDefault();
            
            let   offset        = 0;
            const target        = $( this ).attr( "href" ) ? $( this ).attr( "href" ) : $( this ).attr( "data-href" );
            const offset_mobile = $( this ).data( "offset-mobile" ) ? $( this ).data( "offset-mobile" ) : 0;
            const duration      = 1000;

            if ( window.matchMedia( "(max-width: 650px)" ).matches ) {
                offset = offset_mobile;
            }
            
            $( 'html, body' ).animate( {
                scrollTop: $( target ).offset().top - offset
            }, duration );
            
        })
    }
    
    static lazy()
    {
        let lazyLoadInstance = new LazyLoad({
            elements_selector: '[data-src], [data-bg]'
        });
    }

    static google_translate()
    {
        const trigger = '[data-trigger="glt-selector"]',
              $element = $('[data-id="glt-selector"]');

        $element.on( 'click', function ( e ) {
            e.preventDefault();

            if ( !$( e.target ).closest( '.gltSelectorInner' ).length ) {
                $( this ).fadeOut();
                updateCurrentLanguageToolbar();
            }
        } );

        $element.find( '.gltSelectorLangs a' ).on( 'click', function ( e ) {
            const href = $(this).attr('href');

            if ( href === '#' ) {
                $element.fadeOut();
                updateCurrentLanguageToolbar();
            } else {
                window.location.href = href;
            }
        } );

        $( trigger ).on( 'click', function ( e ) {
            e.preventDefault();

            $element.fadeIn();
        } );

        var updateCurrentLanguageToolbar = function () {

            window.setTimeout( function () {

                var current_language = $( 'html' ).attr( 'lang' ).replace( /-.*/gi, '' );

                if ( current_language == 'auto' ) {
                    current_language = 'fr';
                }

                $( trigger ).text( current_language );
            }, 500 );
        };

        $( window ).on( 'load', function () {
            updateCurrentLanguageToolbar();
        } );
    }

    static on_scroll()
    {
        var last_scroll_top = 0;
        $( window ).on( 'load scroll', function () {

            var scroll_top = $( this ).scrollTop();

            if ( scroll_top >= last_scroll_top && scroll_top > $( '.navbar' ).outerHeight() ) {
                // Down
                $( 'body' ).addClass( 'is-header-hidden' );
            } else {
                // Up
                $( 'body' ).removeClass( 'is-header-hidden' );
            }
            last_scroll_top = scroll_top;

            // Site header collapsed
            if ( scroll_top > 0 ) {
                // Down
                $('body').addClass('is-header-sticky');
            } else {
                // Up
                $('body').removeClass('is-header-sticky');
            }

            // Back to top
            if ( scroll_top > 250 ) {
                $( '[data-id="back-to-top"]' ).addClass( 'backtotop--show' );
            } else {
                $( '[data-id="back-to-top"]' ).removeClass( 'backtotop--show' );
            }
        } );
    }

    static match_height()
    {
        const $element = $( '[data-mh]' );
        
        if ( $element.length > 0 ) {
            setTimeout( function() {
                $element.matchHeight();
            }, 0);
        }
    }

    static gallery_photos()
    {
        if ( $('.gallery-photos').length > 0 ) {

            var $grid = $('.grid').isotope({
                itemSelector: '.grid-item',
                stamp: '.stamp',
                percentPosition: true,
                masonry: {
                    columnWidth: '.grid-sizer'
                }
            });

            // layout Isotope after each image loads
            $grid.imagesLoaded().progress(function () {
                $grid.isotope('layout');
            });

            $('#gallery-photos-categories a').on('click', function (e)
            {
                e.preventDefault();

                if (!$(this).closest('.cat-item').hasClass('is-active')) {

                    var filter = $(this).data('filter');

                    $('#gallery-photos-categories .cat-item').removeClass('is-active');
                    $(this).closest('.cat-item').addClass('is-active');

                    $grid.isotope({filter: filter});
                }
            });
        }
    }

    static gallery_videos()
    {
        if ( $('.webtvSlider').length > 0 ) {

            $('.webtvSlider').slick({
                infinite: false,
                accessibility: false,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 5000,
                arrows: false,
                dots: true,
                pauseOnHover: true,
            });
        }

        if ( $('.gallery-videos').length > 0 ) {

            var $grid = $('.gallery-videos').isotope({
                itemSelector: '.grid-item',
                stamp: '.stamp',
                percentPosition: true,
                masonry: {
                    columnWidth: '.grid-sizer'
                }
            });

            // Filter items on button click
            $('.filters').on('change', function ()
            {
                var filterValue = $(this).val();
                $grid.isotope({filter: filterValue});
            });
        }
    }

    static blog()
    {

        if ( $('.list-post').length > 0 ) {
            
            var $grid = $('.list-post').isotope({
                itemSelector: '.grid-item',
                stamp: '.stamp',
                percentPosition: true,
                masonry: {
                    columnWidth: '.grid-sizer'
                }
            });

            // layout Isotope after each image loads
            $grid.imagesLoaded().progress( function() {
                $grid.isotope('layout');
            });
        }

        $('.js-trigger-tags').on('click', function(e) {
            e.preventDefault();

            var total_to_show = $('.list-tags').data('tags-to-show');
            var $tags_hidden  = $('.list-tags .cat-item.hidden');
            var total_remains = $tags_hidden.length - total_to_show;

            $tags_hidden.slice(0, total_to_show).removeClass('hidden');

            if ( total_remains < 1 ) {
                $(this).remove();
            }
        });

        $('#list-tags:not(.is-category) a').on('click', function(e) {
            e.preventDefault();

            if ( !$(this).closest('.cat-item').hasClass('is-active') ) {

                var filter = $(this).data('filter');

                $('#list-tags .cat-item').removeClass('is-active');
                $(this).closest('.cat-item').addClass('is-active');

                $grid.isotope({ filter: filter });
            }
        });
    }

    static flow_flow()
    {
        if ( $('.ff-stream').length > 0 ) {

            $('.ff-stream').each( function() {
                var $that = $(this);

                if ( $that.siblings('script').is(':last-child') ) {
                    $that.addClass('is-last-child');
                }
            });
        }
    }

    static responsive()
    {
        
        $( '.js-trigger-menu' ).on( 'click', function ( e ) {
            e.preventDefault();
            
            $( 'body' ).toggleClass( 'menu-revealed overlay-active' );
        } );
        
        $( '#site-overlay' ).on( 'click', function ( e ) {
            e.preventDefault();
            
            $( 'body' ).removeClass( 'menu-revealed overlay-active' );
        } );

        // Menu click touch devices
        if ( Modernizr.touchevents ) {
            $('.mainnav .menu > .menu-item-has-children').on('click', function(e) {
                let $that = $(this);

                if ( !$that.hasClass('is-clickable') ) {
                    e.preventDefault();
                    $that.addClass('is-clickable');
                }

                $('.mainnav .menu > .menu-item-has-children.is-clickable').not($that).removeClass('is-clickable');
            });
        }
        
        var responsive = function () {
            
            // Tablet
            if ( window.matchMedia( "(max-width: 1000px)" ).matches ) {
                
                // Swipe menu
                $( '.trigger-nav-subcat' ).remove();
                $( '#site-menu__mobile__wrapper .menu-item-has-children > a' ).prepend( '<button type="button" class="trigger-nav-subcat" aria-label="' + Theme.translate.submenu + '"><i class="fi fi-arrow-right"></i></button>' );
                $( '.trigger-nav-back' ).remove();
                $( '#site-menu__mobile__wrapper .sub-menu' ).prepend( '<button type="button" class="button button--white trigger-nav-back" aria-label="' + Theme.translate.back + '"><i class="fi fi-arrow-left"></i> ' + Theme.translate.back + '</button>' );
                
                // Toolbar
                $( '.tools .toolsItem--lang' ).appendTo( '.site-menu__mobile__tools' );
                $( '.tools .toolsItem--weather' ).appendTo( '.site-menu__mobile__tools' );
                $( '.tools .toolsItem--contact' ).appendTo( '.site-menu__mobile__tools' );
                
                // // Homepage
                // $( '.hero .hotNews' ).prependTo( '#main' );
                
            } else {
                
                // Swipe menu
                $( '.trigger-nav-subcat' ).remove();
                $( '.trigger-nav-back' ).remove();
                
                // Toolbar
                $( '.site-menu__mobile__tools .toolsItem--weather' ).prependTo( '.tools' );
                $( '.site-menu__mobile__tools .toolsItem--lang' ).prependTo( '.tools' );
                $( '.site-menu__mobile__tools .toolsItem--contact' ).insertAfter( '.tools .toolsItem--phone' );
                
                // // Homepage
                // $( '#main .hotNews' ).appendTo( '.hero' );
            }
            
            // // Mobile
            // if ( window.matchMedia("(max-width: 650px)").matches ) {
            
            //    // Homepage
            //    $('.hp-section-4 .col-right .tf-slider-wrapper').insertAfter('.hp-section-4 .col-left .hp-section-title');
            //    $('.hp-section-5 .postItemFixed .postItemFixedCta').insertAfter('.hp-section-5 .postSlider');
            
            // } else {
            
            //    // Homepage
            //    $('.hp-section-4 .col-left .tf-slider-wrapper').prependTo('.hp-section-4 .col-right');
            //    $('.hp-section-5 .postSliderWrapper > .postItemFixedCta').insertAfter('.hp-section-5 .postItemFixedContent');
            // }
        };
        
        // Swipe menu
        $( '#site-menu__mobile__wrapper' ).on( 'click', '.trigger-nav-subcat', function ( e ) {
            e.preventDefault();
            
            $( '#site-menu__mobile__wrapper .menu-item-has-children' ).not( $( this ).parents( '.is-active-subcat' ) ).removeClass( 'is-active-subcat' );
            
            if ( !$( this ).closest( '.menu-item-has-children' ).hasClass( 'is-active-subcat' ) ) {
                
                $( this ).closest( '.menu-item-has-children' ).addClass( 'is-active-subcat' );
            }
        } );
        
        $( '#site-menu__mobile__wrapper' ).on( 'click', '.trigger-nav-back', function ( e ) {
            e.preventDefault();
            
            $( this ).closest( '.is-active-subcat' ).removeClass( 'is-active-subcat' );
        } );
        
        $( window ).on( 'resize', responsive );
        responsive();
    }
}
